/** Plain-text excerpt for in-app notification previews (handles saved HTML notes). */
export function plainNotificationPreview(raw: string, maxLen = 320): string {
  const withMentionText = raw.replace(
    /<span[^>]*class="mention"[^>]*data-mention-user-id="[^"]*"[^>]*>([^<]*)<\/span>/gi,
    (_, inner) => String(inner).trim(),
  );
  const text = withMentionText
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/(p|div|li)>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > maxLen ? `${text.slice(0, maxLen - 1)}…` : text;
}

const MENTION_IN_PREVIEW_RE = /@([a-zA-Z0-9._-]+(?:\s+[A-ZÄÖÜa-zäöü][a-zA-Z0-9._äöüÄÖÜß-]*)?)/g;

export function splitNotificationPreviewMentions(text: string): Array<{ type: 'text' | 'mention'; value: string }> {
  const parts: Array<{ type: 'text' | 'mention'; value: string }> = [];
  let last = 0;
  const re = new RegExp(MENTION_IN_PREVIEW_RE.source, 'g');
  let match: RegExpExecArray | null;
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      parts.push({ type: 'text', value: text.slice(last, match.index) });
    }
    parts.push({ type: 'mention', value: match[0] });
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    parts.push({ type: 'text', value: text.slice(last) });
  }
  return parts;
}